import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import exportValue from "../../apiconfig";

const GenerateInvoice = () => {
  const [loading, setLoading] = useState(false);

  const [invoiceMonth, setInvoiceMonth] = useState("");
  const [financialYear, setFinancialYear] = useState("");

  const [summary, setSummary] = useState({
    checked: false,
    already_generated: false,
    customer_count: 0,
    next_invoice: "",
    financial_year: "",
  });

  const checkInvoice = async () => {
    if (!invoiceMonth) {
      Swal.fire({
        icon: "warning",
        title: "Select Invoice Month",
        text: "Please select invoice month.",
      });
      return;
    }
    if (!financialYear) {
      Swal.fire({
        icon: "warning",
        title: "Select Financial year",
        text: "Financial year is required.",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/check_generate_invoice",
        {
          invoice_month: invoiceMonth,
          financial_year: financialYear,
        },
        { headers: exportValue.headers }
      );

      if (response.data.status) {
        setSummary({
          checked: true,
          already_generated: response.data.output.already_generated,
          customer_count: response.data.output.customer_count,
          next_invoice: response.data.output.next_invoice,
          financial_year: response.data.output.financial_year,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (err) {
      console.log(err);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong.",
      });
    }

    setLoading(false);
  };

  const generateInvoice = async () => {
    const result = await Swal.fire({
      title: "Generate Invoice?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Generate",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      const response = await axios.post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/create_invoice",
        {
          invoice_month: invoiceMonth,
          financial_year: financialYear,
        },
        { headers: exportValue.headers }
      );

      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });

        checkInvoice();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (err) {
      console.log(err);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Unable to generate invoice.",
      });
    }

    setLoading(false);
  };

  const getFinancialYears = () => {
    const today = new Date();

    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const startYear = currentMonth >= 4 ? currentYear : currentYear - 1;

    return Array.from({ length: 5 }, (_, index) => {
      const year = startYear + index;

      return `${String(year).slice(-2)}-${String(year + 1).slice(-2)}`;
    });
  };

  return (
    <div className="container-fluid">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <h5 className="mb-0 fw-bold">Generate Monthly Invoice</h5>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Invoice Month</label>

              <input
                type="month"
                className="form-control"
                value={invoiceMonth}
                onChange={(e) => setInvoiceMonth(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Financial Year</label>

              <select
                className="form-select"
                value={financialYear}
                onChange={(e) => setFinancialYear(e.target.value)}
              >
                <option value="">Select Financial Year</option>
                {getFinancialYears().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={checkInvoice}
                disabled={loading}
              >
                Check
              </button>
            </div>
          </div>

          {summary.checked && (
            <>
              <hr />

              <div className="row">
                <div className="col-md-3">
                  <div className="border rounded p-3">
                    <small className="text-muted">Financial Year</small>

                    <h5 className="mt-2">{summary.financial_year}</h5>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="border rounded p-3">
                    <small className="text-muted">Eligible Customers</small>

                    <h5 className="mt-2">{summary.customer_count}</h5>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="border rounded p-3">
                    <small className="text-muted">Next Invoice</small>

                    <h5 className="mt-2">{summary.next_invoice}</h5>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="border rounded p-3">
                    <small className="text-muted">Status</small>

                    <h5
                      className={`mt-2 ${
                        summary.already_generated
                          ? "text-danger"
                          : "text-success"
                      }`}
                    >
                      {summary.already_generated
                        ? "Already Generated"
                        : "Ready"}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <button
                  className="btn btn-success"
                  disabled={
                    loading ||
                    summary.already_generated ||
                    summary.customer_count === 0
                  }
                  onClick={generateInvoice}
                >
                  {loading ? "Generating..." : "Generate Invoices"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenerateInvoice;
